import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Navigation = () => {
  const location = useLocation();
  const { FiHome, FiEdit, FiBookOpen, FiImage, FiMessageSquare, FiFileText, FiVideo, FiLayout } = FiIcons;

  const navItems = [
    { path: '/', label: 'Dashboard', icon: FiHome },
    { path: '/generator', label: 'Generator', icon: FiEdit },
    { path: '/blog', label: 'Blog', icon: FiBookOpen },
    { path: '/carousel', label: 'Carousel', icon: FiImage },
    { path: '/captions', label: 'Captions', icon: FiMessageSquare },
    { path: '/media-kit', label: 'Media Kit', icon: FiFileText },
    { path: '/tiktok', label: 'TikTok', icon: FiVideo },
    { path: '/landing', label: 'Landing Page', icon: FiLayout }
  ];

  return (
    <nav className="bg-gray-800 border-b border-gray-700">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiImage} className="text-2xl text-yellow-400" />
            <h1 className="text-xl font-bold text-white">Clarity with Jahx Travel Content Ecosystem</h1>
          </div>

          <div className="hidden md:flex space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === item.path
                    ? 'bg-yellow-500 text-black'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                }`}
              >
                <div className="flex items-center space-x-2">
                  <SafeIcon icon={item.icon} className="text-sm" />
                  <span className="hidden md:inline">{item.label}</span>
                </div>
              </Link>
            ))}
          </div>

          {/* Mobile navigation */}
          <div className="md:hidden flex overflow-x-auto space-x-1 pb-2 -mb-2 scrollbar-hide">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`p-2 rounded-md flex flex-col items-center justify-center min-w-[50px] ${
                  location.pathname === item.path
                    ? 'bg-yellow-500 text-black'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                }`}
              >
                <SafeIcon icon={item.icon} className="text-lg" />
                <span className="text-xs mt-1">{item.label.split(' ')[0]}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;